<button
  [title]="tooltip"
  [class]="this._buttonClass"
  [type]="type"
  [class.incompress]="true">
  <i *ngIf="iconClass !== ''" [class]="initIconClass()"></i>
  {{label}}
</button>
